import { useState } from 'react';

import { Dialog, DialogActions, Button } from '@material-ui/core';
import ArrowForwardIcon from '@material-ui/icons/ArrowForward';
import 'assets/scss/portabilidad-dialog.scss';
import checkIsMobile from 'utils/CheckIsMobile';

interface DialogInfoPortabilidadProps {
	onClose: () => void;
}

export const DialogInfoPortabilidad = ({ onClose }: DialogInfoPortabilidadProps) => {
	const [open, setOpen] = useState(true);

	const handleClose = () => {
		onClose();
		setOpen(false);
	};
	const size = checkIsMobile() ? 'medium' : 'large';
	return (
		<Dialog
			disableBackdropClick
			disableEscapeKeyDown
			open={open}
			onClose={handleClose}
			aria-labelledby="alert-dialog-title"
			aria-describedby="alert-dialog-description"
			className="portabilidad-dialog"
		>
			<div id="alert-dialog-title" className="portabilidad-dialog-title">
				Completa la solicitud
			</div>
			<div className="portabilidad-dialog-separador"></div>
			<div className="portabilidad-dialog-content">
				<p>
					La información que te pediremos a continuación es necesaria para agilizar tu evaluación
					crediticia.
				</p>
				<br />
				<p>
					En sólo <strong>6 pasos</strong> completa la solicitud y un ejecutivo se contactará
					contigo.
				</p>
				<br />
				<p>
					<strong>
						Recuerda tener a mano tu cédula de identidad y nº de la patente del vehículo que quieres
						portar.
					</strong>
				</p>
			</div>
			<DialogActions>
				<Button
					onClick={handleClose}
					variant="contained"
					color="primary"
					size={size}
					endIcon={<ArrowForwardIcon />}
				>
					entendido
				</Button>
			</DialogActions>
		</Dialog>
	);
};
